module.exports = __webpack_public_path__ + "img/finance-verify.c3eeb940.svg";